module.exports = require('./lib/client/index');



//////////////////
// WEBPACK FOOTER
// ./~/feathers/client.js
// module id = 543
// module chunks = 11